import { defineComponent as _defineComponent } from 'vue'
import { openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, createElementVNode as _createElementVNode, toDisplayString as _toDisplayString, unref as _unref } from "vue"

const _hoisted_1 = {
  key: 0,
  class: "tw3-flex tw3-flex-col tw3-items-stretch tw3-gap-5 tw3-rounded-2xl tw3-border tw3-border-surface-200 tw3-bg-surface-0 tw3-p-5 tw3-shadow-sm sm:tw3-flex-row sm:tw3-items-center"
}
const _hoisted_2 = { class: "tw3-mx-auto tw3-flex tw3-h-20 tw3-w-40 tw3-shrink-0 tw3-items-center tw3-justify-center tw3-overflow-hidden tw3-rounded-xl sm:tw3-mx-0" }
const _hoisted_3 = ["src"]
const _hoisted_4 = {
  key: 1,
  class: "pi pi-car !tw3-text-3xl tw3-text-surface-300"
}
const _hoisted_5 = { class: "tw3-min-w-0 tw3-flex-1" }
const _hoisted_6 = { class: "tw3-flex tw3-items-start tw3-justify-between tw3-gap-4" }
const _hoisted_7 = { class: "tw3-text-lg tw3-font-bold tw3-leading-tight tw3-text-surface-900" }
const _hoisted_8 = { class: "tw3-mt-0.5 tw3-text-sm tw3-text-surface-500" }
const _hoisted_9 = { class: "tw3-mt-3 tw3-flex tw3-flex-wrap tw3-items-end tw3-gap-3" }
const _hoisted_10 = {
  key: 0,
  class: "tw3-flex tw3-items-center tw3-gap-2 tw3-rounded-lg tw3-border tw3-border-surface-200 tw3-bg-surface-50 tw3-px-2.5 tw3-py-1.5"
}
const _hoisted_11 = { class: "tw3-font-mono tw3-text-xs tw3-tracking-wider tw3-text-surface-800" }
const _hoisted_12 = {
  key: 1,
  class: "tw3-inline-flex tw3-flex-col tw3-items-center tw3-rounded-md tw3-border-2 tw3-border-surface-300 tw3-bg-surface-50 tw3-px-2.5 tw3-py-0.5 tw3-leading-tight"
}
const _hoisted_13 = { class: "tw3-flex tw3-justify-center" }
const _hoisted_14 = { class: "tw3-mx-2 tw3-text-[0.6rem] tw3-text-gray-500" }
const _hoisted_15 = { class: "tw3-text-sm tw3-font-bold tw3-tracking-wide tw3-text-surface-700" }
const _hoisted_16 = ["src"]

import { computed } from 'vue';

import { useBookingQuoteStore } from '@/entities/quickQuote/lib/booking-store';
import { US_STATES } from '@/shared/constants';

import type { EstimateVehicle } from '@/entities/quickQuote/lib/booking-api.types';


export default /*@__PURE__*/_defineComponent({
  __name: 'BookingVehicleCard',
  props: {
    vehicle: {}
  },
  setup(__props: any) {

const props = __props;

const bookingStore = useBookingQuoteStore();

const vehicleLogo = computed(() => {
	try {
		return require(`@/assets/img/car-logos/${props.vehicle.makeId}.png`);
	} catch (err) {
		return null;
	}
});

const hasPlate = computed(() => Boolean(bookingStore.vehiclePlate?.number));

const plateNumber = computed(() => {
	if (bookingStore.vehiclePlate?.number) {
		return bookingStore.vehiclePlate.number.toUpperCase();
	}

	return '';
});

return (_ctx: any,_cache: any) => {
  return (_ctx.vehicle)
    ? (_openBlock(), _createElementBlock("div", _hoisted_1, [
        _createElementVNode("div", _hoisted_2, [
          (_ctx.vehicle.imageUrl)
            ? (_openBlock(), _createElementBlock("img", {
                key: 0,
                alt: "vehicle",
                class: "tw3-h-full tw3-w-full tw3-object-contain",
                src: _ctx.vehicle.imageUrl
              }, null, 8, _hoisted_3))
            : (_openBlock(), _createElementBlock("i", _hoisted_4))
        ]),
        _createElementVNode("div", _hoisted_5, [
          _createElementVNode("div", _hoisted_6, [
            _createElementVNode("div", null, [
              _createElementVNode("div", _hoisted_7, _toDisplayString(_ctx.vehicle.year) + " " + _toDisplayString(_ctx.vehicle.make) + " " + _toDisplayString(_ctx.vehicle.model), 1),
              _createElementVNode("p", _hoisted_8, _toDisplayString(_ctx.vehicle.subModel) + " " + _toDisplayString(_ctx.vehicle.style), 1)
            ])
          ]),
          _createElementVNode("div", _hoisted_9, [
            (_ctx.vehicle.vin)
              ? (_openBlock(), _createElementBlock("div", _hoisted_10, [
                  _cache[0] || (_cache[0] = _createElementVNode("span", { class: "tw3-text-[0.6rem] tw3-font-bold tw3-tracking-wider tw3-text-surface-400" }, " VIN ", -1)),
                  _createElementVNode("span", _hoisted_11, _toDisplayString(_ctx.vehicle.vin), 1),
                  _cache[1] || (_cache[1] = _createElementVNode("span", { class: "tw3-flex tw3-size-4 tw3-items-center tw3-justify-center tw3-rounded-full tw3-bg-primary-500" }, [
                    _createElementVNode("i", { class: "pi pi-check !tw3-text-[0.45rem] tw3-font-bold tw3-text-white" })
                  ], -1))
                ]))
              : _createCommentVNode("", true),
            (hasPlate.value)
              ? (_openBlock(), _createElementBlock("div", _hoisted_12, [
                  _createElementVNode("div", _hoisted_13, [
                    _cache[2] || (_cache[2] = _createElementVNode("i", {
                      class: "pi pi-circle-fill tw3-mt-1",
                      style: {"color":"#708090","font-size":"0.2rem"}
                    }, null, -1)),
                    _createElementVNode("div", _hoisted_14, _toDisplayString(_unref(US_STATES).find(
									v => v.value === _unref(bookingStore).vehiclePlate?.state
								)?.title || 'STATE'), 1),
                    _cache[3] || (_cache[3] = _createElementVNode("i", {
                      class: "pi pi-circle-fill tw3-mt-1",
                      style: {"color":"#708090","font-size":"0.2rem"}
                    }, null, -1))
                  ]),
                  _createElementVNode("span", _hoisted_15, _toDisplayString(plateNumber.value), 1)
                ]))
              : _createCommentVNode("", true)
          ])
        ]),
        (vehicleLogo.value)
          ? (_openBlock(), _createElementBlock("img", {
              key: 0,
              alt: "logo",
              class: "tw3-h-20 tw3-shrink-0 tw3-object-contain",
              src: vehicleLogo.value
            }, null, 8, _hoisted_16))
          : _createCommentVNode("", true)
      ]))
    : _createCommentVNode("", true)
}
}

})